import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import InvestmentIncomeDetails from "./InvestmentIncomeDetails";
import { formatAmount } from "../../../../../utils/hooks/dataHandler";

const CappedCommonExpenseBlock = ({
  cappedRate,
  expenseCappedAmount,
  handleCappedAt,
  grossInvestmentIncomeInfo,
  incomeRows,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <InvestmentIncomeDetails
        incomeRows={incomeRows}
        baseLabel={grossInvestmentIncomeInfo.label}
        baseAmount={grossInvestmentIncomeInfo.amount}
        cappedRate={cappedRate}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant='h6'
          sx={{
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            fontSize: { xs: "1rem", md: "1.15rem" },
          }}
        >
          Common Expense capped at&nbsp;
          <TextField
            type='number'
            value={cappedRate}
            onChange={(e) => handleCappedAt(e.target.value)}
            InputProps={{
              inputProps: { min: 0, max: 100 },
              disableUnderline: true,
            }}
            sx={{
              mx: 1,
              width: 70,
              "& input": {
                textAlign: "center",
                fontWeight: 600,
                fontSize: "1.1em",
                color: "secondary.main",
                bgcolor: "background.paper",
                borderRadius: 1,
                px: 1,
                py: 0.5,
                border: "1px solid",
                borderColor: "divider",
              },
            }}
            variant='standard'
          />
          % of Total Income
        </Typography>
        <Typography
          variant='h6'
          sx={{
            fontWeight: 600,
            color: "secondary.main",
            fontSize: { xs: "1rem", md: "1.15rem" },
          }}
        >
          {formatAmount(expenseCappedAmount)}
        </Typography>
      </Box>
    </Box>
  );
};

export default CappedCommonExpenseBlock;
